import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useEquipmentListStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchField: {
      marginBottom: '30px',
      width: '100%',
    },
    gridList: {
      width: '100%',
    },
    formControl: {
      width: '100%',
      marginTop: theme.typography.pxToRem(16),
      marginBottom: theme.typography.pxToRem(8),
    },
    listItem: {
      width: '100%',
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '8px',
      marginBottom: theme.spacing(1.5),
      alignItems: 'center',
      padding: theme.spacing(1.5),
    },
    imageContainer: {
      width: 64,
      height: 64,
      minWidth: 64,
      borderRadius: '3px',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
      marginRight: theme.spacing(2),
    },
    fallbackIcon: {
      fontSize: '32px',
      color: 'lightgray',
    },
    itemName: {
      fontWeight: 600,
      fontSize: '1rem',
    },
    itemDetail: {
      color: theme.palette.text.secondary,
      fontSize: '0.875rem',
      marginTop: theme.spacing(0.25),
    },
  })
);
